var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (articles, remaining, undefined) {
buf.push("<div class=\"show-related-articles\"><div class=\"show-related-articles-title\">Articles Related to the Show</div>");
// iterate articles
;(function(){
  var $$obj = articles;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var article = $$obj[$index];

buf.push("<div class=\"show-related-article\"><div class=\"show-related-article-image\"><a" + (jade.attr("href", article.href, true, true)) + "><img" + (jade.attr("src", article.thumbnail_image.cropped.url, true, true)) + (jade.attr("alt", article.title, true, true)) + "></a></div><div class=\"show-related-article-info\"><a" + (jade.attr("href", article.href, true, true)) + "><div class=\"show-related-article-title\">" + (jade.escape(null == (jade_interp = article.thumbnail_title) ? "" : jade_interp)) + "</div></a><div class=\"show-related-article-author\">By " + (jade.escape((jade_interp = article.author.name) == null ? '' : jade_interp)) + "</div></div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var article = $$obj[$index];

buf.push("<div class=\"show-related-article\"><div class=\"show-related-article-image\"><a" + (jade.attr("href", article.href, true, true)) + "><img" + (jade.attr("src", article.thumbnail_image.cropped.url, true, true)) + (jade.attr("alt", article.title, true, true)) + "></a></div><div class=\"show-related-article-info\"><a" + (jade.attr("href", article.href, true, true)) + "><div class=\"show-related-article-title\">" + (jade.escape(null == (jade_interp = article.thumbnail_title) ? "" : jade_interp)) + "</div></a><div class=\"show-related-article-author\">By " + (jade.escape((jade_interp = article.author.name) == null ? '' : jade_interp)) + "</div></div></div>");
    }

  }
}).call(this);

if ( remaining > 0)
{
buf.push("<div class=\"related-articles-show-all avant-garde-button-white is-block\">Show More Related Articles (" + (jade.escape((jade_interp = remaining) == null ? '' : jade_interp)) + ")</div>");
}
buf.push("</div>");}.call(this,"articles" in locals_for_with?locals_for_with.articles:typeof articles!=="undefined"?articles:undefined,"remaining" in locals_for_with?locals_for_with.remaining:typeof remaining!=="undefined"?remaining:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;